module.exports = __webpack_public_path__ + "media/images/cart/cart_btn03-206c0a373c41e0e20f80bb2e1bad5aac.gif";